export default __webpack_public_path__ + "static/media/img6.5d31f065.jpg";